import React from 'react';
import { Col, Row, Button } from "react-bootstrap";
import * as Formatting from 'fw/misc/Formatting';
import * as Notifications from 'fw/globals/Notifications';
import * as APIRoutes from 'modules/app/API';
import API from 'fw/system/API';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppealRequestPopUp from 'areas/shared/modals/AppealRequestPopUp/AppealRequestPopUp';

library.add(fas, fab);

class CertificationCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isHovering: false,
			showAppealRequestPopUp: false,
        }
    }

	shouldComponentUpdate(nextProps, nextState) {
		return (
            nextProps !== this.props
            || nextState.isHovering !== this.state.isHovering)
			|| nextState.showAppealRequestPopUp !== this.state.showAppealRequestPopUp;
	}

    setIsHovering = (status) => {
        this.setState({
            isHovering: status
        })
    };

    handleMouseOver = () => {
        this.setIsHovering(true);
    };

    handleMouseOut = () => {
        this.setIsHovering(false);
    };

    onAppealClick = () => {
		this.setState({
			showAppealRequestPopUp: true
		});
    }

	onHandleRequestAppeal = (data) => {
		var rq = {
			certificationId: data.certificationId,
			appealReason: data.appealReason
		};
		
		var url = APIRoutes.Admin.url("/certification/appealRequest");

        this.setState({
			showAppealRequestPopUp: false,
        }, function () {
            new API().post(url, rq, {
                success: (r) => {
					Notifications.success(r.message);
					window.location.reload();
                },
                error: r => {
					Notifications.error(r.error);
                }
            })
        });
	}

	onAppealRequestPopUpClose = () => {
		this.setState({
            showAppealRequestPopUp: false
        });
	}

    renderAppealButtons = (certificationLink, appealInProgress) => {
        return (
            <Row>
                <Col md={6} style={{paddingLeft:6, paddingRight:3}}>
                    <Button
                        onMouseOver={this.handleMouseOver}
                        onMouseOut={this.handleMouseOut}
                        bsClass={`btn btn-block btn-lg btn-success`}
                        href={certificationLink}>
                        <b>RE-APPLY</b>
                    </Button>
                </Col>
                <Col md={6} style={{paddingLeft:3, paddingRight:6}}>
                    <Button
                        bsClass={`btn btn-block btn-lg btn-warning`}
                        disabled={appealInProgress}
                        title={appealInProgress ? "Appeal under review" : ""}
                        onClick={this.onAppealClick}>
                        <b>APPEAL</b>
                    </Button>
                </Col>
            </Row>);
    }

    // NVBDC-1404: for in-progress renewals, the one-sheet form is the sole Dashboard entry point.
    // The classic multi-page wizard is still reachable from inside the one-sheet ("Switch to full
    // multi-page form", OneSheetRenewal.js) and vice versa ("Try the One-Sheet form",
    // comps/Navigator.js) — only the redundant second Dashboard button is removed.
    renderInProgressRenewalButtons = (oneSheetLink) => {
        return (
            <Button
                onMouseOver={this.handleMouseOver}
                onMouseOut={this.handleMouseOut}
                bsClass={`btn btn-block btn-info`}
                href={oneSheetLink}>
                <b>ONE-SHEET RENEWAL</b>
            </Button>);
    }

	render() {
        let certificationKey = this.props.certificationKey;
        let certificationId = this.props.certificationId;
        let certificationStatus = this.props.certificationStatus;
        let expirationDays = this.props.expirationDays;
        let expirationDate = this.props.expirationDate;
        let renewalAvailable = this.props.renewalAvailable;
        let vobName = this.props.vobName;
        let vobFein = this.props.vobFein;
        let vobFeinKey = this.props.vobFeinKey;
        let vobKey = this.props.vobKey;
        let daysInDraft = this.props.daysInDraft;
        let submitDate = this.props.submitDate;
        let stepCode = this.props.stepCode;
        let appealAvailable = this.props.appealAvailable;
        let appealInProgress = this.props.appealInProgress;
        let preQualificationCreateDate = this.props.preQualificationCreateDate;
        let isRenewal = this.props.isRenewal;
        let oneSheetLink = "";
        let boxLink = false;

        let daysInDraftBadge = '';
        if (daysInDraft < 30)
            daysInDraftBadge = "success";
        else if (daysInDraft >= 30 && daysInDraft <= 60)
            daysInDraftBadge = "warning";
        else if (daysInDraft > 60)
            daysInDraftBadge = "danger";

        let panelType = "default";
        let bgButton = "default";
        let certificationLink = "";
        let iconColor = "";
        let iconName = "";
        let boxFooterLabel = "";
        let dragOverColor = "";
        let boxBodyText = "";

        switch (certificationStatus) {
            case "prequalification":
                panelType = "warning";
                bgButton = "success";
                boxLink = true;
                certificationLink = '/certification/preQualification/' + vobKey;
                iconColor = "#f39c12";
                iconName = "pencil-alt";
                boxFooterLabel = "CONTINUE PRE-QUALIFICATION";
                dragOverColor = "#008d4c";
                break;
            case "inProgress":
                panelType = "info";
                bgButton = "primary";
                certificationLink = '/certification/certification/' + stepCode + '/' + certificationKey;
                oneSheetLink = '/certification/renewalOneSheet/' + certificationKey;
                iconColor = "#3c8dbc";
                iconName = "pencil-alt";
                boxFooterLabel = "CONTINUE APPLICATION";
                dragOverColor = "blue";
                // Renewals get two entry points (classic wizard + one-sheet); everything else
                // keeps the single-link card, same as before.
                boxLink = !isRenewal;
                break;
            case "approved":
                panelType = "info";
                bgButton = "primary";
                boxLink = true;
                certificationLink = `/manageCompany/${certificationKey}`;
                iconColor = "#3c8dbc";
                iconName = "check-circle";
                boxFooterLabel = "MANAGE COMPANY";
                dragOverColor = "blue";
                break;
            case "expiring":
                panelType = expirationDays < 0 ? "danger" : "warning";
                bgButton = "success";
                boxLink = true;
                certificationLink = '/certification/addPreQualification/' + vobFeinKey;
                iconColor = expirationDays < 0 ? "#dd4b39" : "#f39c12";
                iconName = expirationDays < 0 ? "exclamation-circle" : "clock";
                boxFooterLabel = renewalAvailable ? "APPLY RENEWAL" : "APPLY RECERTIFICATION";
                dragOverColor = "#008d4c";
                break;
            case "denied":
                panelType = "danger";
                bgButton = "success";
                boxLink = !appealAvailable;
                certificationLink = '/certification/addPreQualification/' + vobFeinKey;
                iconColor = "#dd4b39";
                iconName = "times-circle";
                boxFooterLabel = "RE-APPLY";
                dragOverColor = "#008d4c";
                break;
            case "payed":
                panelType = "success";
                bgButton = "success";
                certificationLink = '/certification/preQualificationPaymentAccepted/' + vobKey;
                iconColor = "#00A65A";
                iconName = "spinner";
                boxFooterLabel = "PAYMENT REVIEW";
                boxBodyText = "Awaiting for PayPal's payment confirmation";
                break;
            default:
                iconName = "spinner";
                iconColor = "#ddd";
                boxFooterLabel = "UNDER REVIEW";
                boxBodyText = "Submitted on " + Formatting.formatDate(submitDate);
                break;
        }

        const dragOverStyle =
        {
            borderColor: dragOverColor,
            WebkitBoxShadow: "inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(31,55,97, 0.6)",
            boxShadow: "inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(31,55,97, 0.6)"
        };
        
        if (boxLink)
        {
            return (
                <a onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut} href={certificationLink}>
                    <div className={`panel panel-${panelType}`} style={this.state.isHovering ? dragOverStyle : null} >
                        <div className="panel-heading" style={{textAlign: 'center'}}>
                            <h3 className="panel-title"><b>FEIN {vobFein}</b></h3>
                        </div>
                        <div className="panel-body" style={{ color: "#333", height: 150, padding: '5px', textAlign: 'center'}}>
                            <p><strong>{vobName}</strong></p>
                            <p>
                                App ID <b>{certificationId}</b> &nbsp;&nbsp;
                                <FontAwesomeIcon icon={iconName} size="1x" color={iconColor} className="my-icon" />
                            </p>
                            {certificationStatus === "inProgress" && daysInDraft &&
                                <span class={`badge alert-${daysInDraftBadge}`} style={{fontSize:"15px"}}>
                                    {daysInDraft} days In Draft
                                </span>
                            }
                            {certificationStatus === "denied" &&
                                <p>
                                    <span class="badge alert-danger" style={{fontSize:"15px"}}>
                                        Certification Denied
                                    </span>
                                </p>
                            }
                            {certificationStatus === "prequalification" && preQualificationCreateDate &&
                                <p>
                                    Created on {Formatting.formatDate(preQualificationCreateDate)}
                                </p>
                            }
                            <em>
                                {expirationDays >= 0 && 
                                    <p>
                                        Certification expires on {Formatting.formatDate(expirationDate)}
                                        <br />
                                        <small>
                                            ({expirationDays} days left)
                                        </small>
                                    </p>
                                }
                                {expirationDays < 0 && 
                                    <p style={{ color: 'red' }}>
                                        Certification expired on {Formatting.formatDate(expirationDate)}
                                        <br />
                                        <small>
                                            ({-expirationDays} days expired)
                                        </small>
                                    </p>
                                }
                            </em>
                        </div>
                        <div className={`panel-footer btn-block btn btn-${bgButton}`} style={{ textAlign:'center', height:55, paddingTop:5 }}>
                            <h4><b>{boxFooterLabel}</b></h4>
                        </div>
                    </div>
                </a>
            );
        }
        
        return (
            <div className={`panel panel-${panelType}`}>
                <div class="panel-heading" style={{textAlign: 'center'}}>
                    <h3 class="panel-title"><b>FEIN {vobFein}</b></h3>
                </div>
                <div className="panel-body" style={{ color: "#333", height: 150, padding: '5px', textAlign: 'center'}}>
                    <p><strong>{vobName}</strong></p>
                    <p>
                        App ID <b>{certificationId}</b> &nbsp;&nbsp;
                        <FontAwesomeIcon icon={iconName} size="1x" color={iconColor} className="my-icon" />
                    </p>
                    {certificationStatus === "denied" ?
                        <React.Fragment>
                            <p>
                                <span class="badge alert-danger" style={{fontSize:"15px"}}>
                                    Certification Denied
                                </span>
                            </p>
                            {appealInProgress &&
                                <p>
                                    <b><em>Appeal Under Review</em></b>
                                </p>
                            }
                        </React.Fragment>
                    : 
                        <p>{boxBodyText}</p>
                    }
                </div>
                <div class="panel-footer" style={{ textAlign:'center', height: 55, paddingTop:5 }}>
                    {certificationStatus === "denied" &&
						<React.Fragment>
							{this.renderAppealButtons(certificationLink, appealInProgress)}
							<AppealRequestPopUp
								certificationId={certificationId}
								header="Appeal Reason"
								label="Enter a reason for this appeal"
								visible={this.state.showAppealRequestPopUp}
								onClose={this.onAppealRequestPopUpClose}
								onConfirm={this.onHandleRequestAppeal}
							/>
						</React.Fragment>
                    }
                    {certificationStatus === "inProgress" && isRenewal &&
                        this.renderInProgressRenewalButtons(oneSheetLink)
                    }
                    {certificationStatus !== "denied" && !(certificationStatus === "inProgress" && isRenewal) &&
                        <h4><b>{boxFooterLabel}</b></h4>
                    }
                </div>
            </div>
        );
	}
}

export default CertificationCard;


// WEBPACK FOOTER //
// ./src/areas/main/dashboard/certificationDashboard/CertificationCard.js